import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

export const BlogPost = () => {
  const { slug } = useParams();
  const { data: post, isLoading, isError } = useQuery({
    queryKey: ["blog", slug],
    queryFn: () => api.get(`/blog/${slug}`).then((r) => r.data),
    retry: false,
  });

  if (isLoading) return <div className="pt-40 text-center text-zinc-500 relative z-10">Caricamento…</div>;
  if (isError || !post) return <div className="pt-40 text-center text-zinc-400 relative z-10">Articolo non trovato. <Link to="/blog" className="text-[#C19A5B]">Torna al blog</Link></div>;

  return (
    <div className="pt-32 pb-24 relative z-10">
      <article className="max-w-3xl mx-auto px-6">
        <Link to="/blog" data-testid="back-to-blog" className="flex items-center gap-2 text-zinc-400 hover:text-[#C19A5B] mb-8 w-fit"><ArrowLeft size={16} /> Torna al blog</Link>
        <span className="eyebrow block">{post.category}</span>
        <h1 className="font-display text-4xl sm:text-5xl text-white leading-tight mt-4 mb-8">{post.title}</h1>
        {post.cover_image && <img src={post.cover_image} alt={post.title} loading="lazy" decoding="async" className="w-full h-[380px] object-cover rounded-2xl border border-white/10 mb-10" />}
        <div className="prose-invert text-zinc-300 text-lg leading-relaxed space-y-5">
          {post.content.split("\n\n").map((para, i) => <p key={i}>{para}</p>)}
        </div>
      </article>
    </div>
  );
};

export default BlogPost;
